"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDocumentSettings = exports.DocumentSettingsProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const defaultSettings = {
    common: {
        backgroundColor: "#ffffff",
        textColor: "#000000",
        accentColor: "#1976d2",
        fontFamily: "Arial",
        fontSize: 12,
        horizontalAlignment: "left",
        verticalAlignment: "top",
    },
    headerFooter: {
        showHeader: false,
        headerText: "Header",
        showFooter: false,
        footerText: "Footer",
    },
    word: {
        pageSize: "A4",
        marginTop: 20,
        marginBottom: 20,
        marginLeft: 20,
        marginRight: 20,
    },
    ppt: {
        slideLayout: "Title & Content",
        transition: "fade",
    },
    pdf: {
        paperSize: "A4",
        includePageNumbers: false,
    },
};
const DocumentSettingsContext = (0, react_1.createContext)(undefined);
const DocumentSettingsProvider = ({ children }) => {
    const [settings, setSettings] = (0, react_1.useState)(defaultSettings);
    const updateSettings = (section, key, value) => {
        setSettings((prev) => (Object.assign(Object.assign({}, prev), { [section]: Object.assign(Object.assign({}, prev[section]), { [key]: value }) })));
    };
    return ((0, jsx_runtime_1.jsx)(DocumentSettingsContext.Provider, { value: { settings, updateSettings, setSettings }, children: children }));
};
exports.DocumentSettingsProvider = DocumentSettingsProvider;
const useDocumentSettings = () => {
    const context = (0, react_1.useContext)(DocumentSettingsContext);
    if (!context) {
        throw new Error("useDocumentSettings must be used within a DocumentSettingsContext");
    }
    return context;
};
exports.useDocumentSettings = useDocumentSettings;
